import script from "./template_16.vue?vue&type=script&setup=true&lang=js"
export * from "./template_16.vue?vue&type=script&setup=true&lang=js"

import "./template_16.vue?vue&type=style&index=0&id=5e1bd5ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1bd5ea"]])

export default __exports__